import { inject, Injectable } from '@angular/core';
import { MaybeAsync } from '@angular/router';
import { selectAuth } from '@app/features/auth/auth.selectors';
import { Store } from '@ngrx/store';
import { AccessService } from 'ngx-mt-ui-lib/services/access';
import { filter, map } from 'rxjs';

@Injectable()
export class AscupAccessService extends AccessService {
  private readonly store = inject(Store);

  public override getAccess(): MaybeAsync<string[]> {
    return this.store.select(selectAuth).pipe(
      filter(
        (auth) =>
          auth.init &&
          !auth.sessionTransitioning &&
          (auth.accessStatus === 'ready' || auth.accessStatus === 'failed'),
      ),
      map((auth) => (auth.accessStatus === 'ready' ? auth.access : [])),
    );
  }
}
